import { lazy } from "react";
import type { RouteObject } from "react-router";
import App from "./app";
import { ProtectedRoute } from "./components/protected-route";
import { NotFound } from "./not-found";
import RootLayout from "./root-layout";

const ManageAssistantsPage = lazy(() =>
  import("./domain/assistant/pages/manage").then((module) => ({
    default: module.ManageAssistantsPage,
  })),
);
const CreateAssistantPage = lazy(() =>
  import("./domain/assistant/pages/create").then((module) => ({
    default: module.CreateAssistantPage,
  })),
);
const EditAssistantPage = lazy(() =>
  import("./domain/assistant/pages/edit").then((module) => ({
    default: module.EditAssistantPage,
  })),
);

const ManageCollectionsPage = lazy(() =>
  import("./domain/collection/pages/manage").then((module) => ({
    default: module.ManageCollectionsPage,
  })),
);
const CreateCollectionPage = lazy(() =>
  import("./domain/collection/pages/create").then((module) => ({
    default: module.CreateCollectionPage,
  })),
);
const EditCollectionPage = lazy(() =>
  import("./domain/collection/pages/edit").then((module) => ({
    default: module.EditCollectionPage,
  })),
);
const BrowseCollectionsPage = lazy(() =>
  import("./domain/collection/pages/browse").then((module) => ({
    default: module.BrowseCollectionsPage,
  })),
);

const ManageAssistantKindsPage = lazy(() =>
  import("./domain/assistant-kind/pages/manage").then((module) => ({
    default: module.ManageAssistantKindsPage,
  })),
);

const ChatPage = lazy(() =>
  import("./domain/chat/pages/chat").then((module) => ({
    default: module.ChatPage,
  })),
);
const VariablesSetupPage = lazy(() =>
  import("./domain/chat/pages/variables-setup").then((module) => ({
    default: module.VariablesSetupPage,
  })),
);

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <App />,
      },
      {
        path: "chat/:assistantId",
        element: <ChatPage />,
      },
      {
        path: "chat/:assistantId/setup",
        element: <VariablesSetupPage />,
      },
      {
        path: "chat/:assistantId/:sessionId",
        element: <ChatPage />,
      },
      {
        path: "collections",
        element: <BrowseCollectionsPage />,
      },
      {
        path: "assistants",
        children: [
          {
            path: "manage",
            element: <ManageAssistantsPage />,
          },
          {
            path: "new",
            element: <CreateAssistantPage />,
          },
          {
            path: ":id/edit",
            element: <EditAssistantPage />,
          },
        ],
      },
      {
        path: "admin",
        children: [
          {
            path: "collections",
            element: <ProtectedRoute capability="canManageCollections" />,
            children: [
              {
                path: "manage",
                element: <ManageCollectionsPage />,
              },
              {
                path: "new",
                element: <CreateCollectionPage />,
              },
              {
                path: ":id/edit",
                element: <EditCollectionPage />,
              },
            ],
          },
          {
            path: "kinds",
            element: <ProtectedRoute capability="canManageAssistantKinds" />,
            children: [
              {
                path: "manage",
                element: <ManageAssistantKindsPage />,
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
